import request from '@/utils/request';
export function loginByUsername(query) {
  return request({
    url: '/employeeLogin/employeeLogin',
    method: 'post',
    params: query
  });
}
export function updatePassword(query) {
  return request({
    url: '/employeeLogin/updatePassword',
    method: 'post',
    params: query
  });
}
export function logout() {
  return request({
    url: '/logout',
    method: 'post'
  });
}
export function getUserInfo(token) {
  return request({
    url: '/perms/staffMenuPerms',
    method: 'get',
    params: {
      token: token
    }
  });
}